/* eslint-disable @typescript-eslint/no-explicit-any */
import { datadogLogs } from '@datadog/browser-logs'
import {
  Box,
  Button,
  CssBaseline,
  ThemeProvider,
  Typography,
} from '@mui/material'

import { darkTheme } from '@kistill/client/shared/ui'

export function ErrorFallback({
  error,
  resetErrorBoundary,
}: {
  error: any
  resetErrorBoundary: any
}) {
  datadogLogs.logger.error('Error caught in ErrorBoundary', error)

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          minHeight: '100vh',
          backgroundColor: 'primary',
          gap: '16px',
        }}
      >
        <Typography variant='h1' style={{ color: 'white' }}>
          Úpps
        </Typography>
        <Typography variant='h2' style={{ color: 'white' }}>
          Óvænt villa hefur komið upp.
        </Typography>
        <Button variant='contained' onClick={resetErrorBoundary} sx={{ mt: 3 }}>
          Reyna aftur
        </Button>
      </Box>
    </ThemeProvider>
  )
}
